import {html} from '@isceco/widget-library2/external/lit'
import WebComponent from '../../WebComponent.js'
import Navigation from '../Navigation/Navigation.js'
import NoContent from '../NoContent/NoContent.js'
import Cockpit from '../Cockpit/Cockpit.js'
import Verbrauch from '../Verbrauch/Verbrauch.js'
import Admin from '../Admin/Admin.js'
import NotAuthorized from '../NotAuthorized/NotAuthorized.js'
import AuthorizationFilter from '../Authorization/AuthorizationFilter.js'
import Gas from '../Gas/Gas.js'
import Massnahmen from '../Massnahmen/Massnahmen.js'


export default class MainView extends WebComponent {

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
    this.oldChild = null
    this.navigationListener = e => {
      // split is used if we have vertical submenu navigation
      this.loadView(e.detail)
    }
    document.addEventListener(Navigation.NAVIGATION_HAPPEND, this.navigationListener)

    this.loadView(getNavigationHash())
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    this.removeEventListener(Navigation.NAVIGATION_HAPPEND, this.navigationListener)
  }

  loadView(linkName) {
    if (isEmpty(linkName)) {
      this.redirectToDefault()
    } else {
      const newChild = this.returnNewChild(linkName)
      if (this.oldChild) {
        this.root.replaceChild(newChild, this.oldChild)
      } else {
        this.root.appendChild(newChild)
      }

      this.oldChild = newChild
    }
  }

  returnNewChild(linkName) { //NOSONAR
    if (!AuthorizationFilter.viewAllowed(linkName)) {
      return new NotAuthorized()
    }
    switch (linkName) {
      case 'Cockpit':
      case '':
          return new Cockpit()
      case 'Verbrauch':
      case 'Verbrauch_Ch':
      case 'Verbrauch_Chot':
      case 'Verbrauch_Dch':
      case 'Verbrauch_Gaznat':
      case 'Verbrauch_Ail':
      case 'Verbrauch_Ego':
      case 'Verbrauch_Egz':
      case 'Verbrauch_Gvm':
        return new Verbrauch()
      case 'Gas':
        return new Gas()
      case 'Massnahmen':
      case 'Massnahmen_Dch':
      case 'Massnahmen_Chot':
      case 'Massnahmen_Gaznat':
      case 'Massnahmen_Ail':
        return new Massnahmen()
      case 'Admin':
      case 'Admin_Parameter':
      case 'Admin_Ml':
      case 'Admin_Tek':
      case 'Admin_Gek':
      case 'Admin_Angebot_Ego':
      case 'Admin_Angebot_Egz':
      case 'Admin_Angebot_Gaznat':
      case 'Admin_Angebot_Gvm':
      case 'Admin_Angebot_Ail':
      case 'Admin_Seg':
      case 'Admin_Monitoring':
      case 'Admin_Export':
      case 'Admin_Audit':
        return new Admin()
      default:
        return new NoContent()
    }
  }

  redirectToDefault() {
    navigate({to: 'Cockpit'})
  }

  getTemplate() {
    return html`gasmonitoring-frontend-main-view`
  }
}

customElements.define('gasmonitoring-frontend-main-view', MainView)
